import React, { useEffect, useState } from 'react'
import { Autocomplete, FormControl, TextField } from '@mui/material'
import { useLang } from '~/hooks/useLang'
import { useHookstate } from '@hookstate/core'
import useDispatchRegistrationWeaponState from '~/features/Dispatch/stores/DispatchRegistrationWeaponState'

interface IWeaponType {
  readonly id: number
  readonly name: string
}

interface FilterAutocompleteWeaponTypeProps {
  readonly onWeaponTypeChange: (value: number | null) => void
  readonly weaponTypeId?: number | null
  readonly disabled?: boolean
  readonly error?: boolean
}

export default function FilterAutocompleteWeaponType({
  disabled,
  weaponTypeId,
  onWeaponTypeChange,
  error
}: FilterAutocompleteWeaponTypeProps) {
  const { translate } = useLang()
  const [options, setOptions] = useState<readonly IWeaponType[]>([])
  const [value, setValue] = useState<IWeaponType | null>(null)
  const loading = useHookstate(false)
  const { getWeaponTypes } = useDispatchRegistrationWeaponState()

  useEffect(() => {
    loading.set(true)
    getWeaponTypes().then((weaponTypes) => {
      setOptions(weaponTypes)
      loading.set(false)

      if (weaponTypeId) {
        const option = weaponTypes.find((option) => option.id === weaponTypeId)
        setValue(option ?? null)
      } else {
        setValue(null)
      }
    })
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (weaponTypeId) {
      const option = options.find((option) => option.id === weaponTypeId)
      setValue(option ?? null)
    } else {
      setValue(null)
    }
  }, [options, weaponTypeId])

  return (
    <FormControl fullWidth>
      <Autocomplete
        disabled={disabled}
        disablePortal
        options={options}
        loading={loading.get()}
        value={value}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        getOptionLabel={(option) => option.name}
        onChange={(event, newValue) => {
          setValue(newValue)
          onWeaponTypeChange(newValue?.id ?? null)
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            error={error}
            label={translate('Tipo de Armamento')}
            size="small"
          />
        )}
      />
    </FormControl>
  )
}
